<template>
  <v-col sm="12">
    <dialog-grafico-cenario
      ref="dialogGraficoCenario"
      :base="base.toLowerCase()"
      :variavel="variavelValor"
      :dialogCenario.sync="dialogCenario"
      :cenario.sync="cenario"
      :loadingSetarCenario="loadingSetarCenario"
      @baixarCenarioTriggered="downloadCenario($event)"
      @setarCenarioTriggered="setarCenario($event)"
    />

    <v-card class="150px max-height: ml-0 mr-0 mt-10 pa-0">
      <v-text-field
        id="cenario-predicao-baixas-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-predicoes ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />

      <v-divider class="mt-10" />

      <v-data-table
        id="cenarios-predicao-baixas-data-table"
        class="cenarios-predicoes-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum cenário disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>

        <template v-slot:[`item.cenario`]="{ item }">
          {{ getTitle(item) }}
        </template>

        <template v-slot:[`item.data_execucao`]="{ item }">
          {{ item.data_execucao | parseToDateTimeBR }}
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="cenario-predicao-baixas-visualizar"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            color="gray"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="item.loading"
            @click="getDadosCenario(item)"
          >
            <v-icon small>mdi-file-eye-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
  import PredicoesBaixasService from '@/services/PredicoesBaixasService.js';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    name: 'CenariosPredicoesBaixasDataTables',

    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogGraficoCenario: () => import('@/components/predicoesBaixas/graficos/DialogGraficoCenario.vue')
    },

    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      base: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      },
      downloadProgressDataCenario: {
        type: Object,
        required: true
      }
    },

    emits: ['update:downloadProgressDataCenario'],

    data: () => ({
      search: undefined,
      idPredicao: '',
      idBaixaTucagem: '',
      variavelValor: '',
      dialogCenario: false,
      loadingSetarCenario: false,
      cenario: {
        id: '',
        faixa: '',
        loading: false,
        cenarioEscolhido: '',
        dados: {}
      },
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Cenário',
          value: 'cenario'
        },
        {
          text: 'Executado',
          value: 'data_execucao'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ]
    }),

    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      _downloadProgressData: {
        get() {
          return this.downloadProgressDataCenario;
        },
        set(newValue) {
          this.$emit('update:downloadProgressDataCenario', newValue);
        }
      }
    },

    methods: {
      getTitle(item) {
        return `${item.predicao_baixa_id}-${item.baixa_tucagem_id}-${item.faixa}-${item.variavel}`;
      },
      getDadosCenario(item) {
        item.loading = true;

        PredicoesBaixasService.getDadosCenario(item.id)
          .then(({ data }) => {
            this.cenario.loading = true;

            this.idPredicao = data.cenario.predicao_baixa_id;
            this.idBaixaTucagem = data.cenario.baixa_tucagem_id;
            this.variavelValor = data.cenario.variavel;
            this.cenario.faixa = data.cenario.faixa;
            this.cenario.id = `${this.idPredicao}-${this.idBaixaTucagem}-${this.cenario.faixa}-${this.variavelValor}`;
            this.cenario.cenarioEscolhido = data.dados.cenarioEscolhido;
            this.cenario.dados = data.dados;

            this.dialogCenario = true;
          })
          .catch((err) => {
            console.log(err);
            this.$toast.error('Erro ao recuperar dados do cenário.', '', { position: 'topRight' });
            this.$refs.dialogGraficoCenario?.clearCenario();
            this.dialogCenario = false;
          })
          .finally(() => {
            this.cenario.loading = false;
            item.loading = false;
          });
      },
      downloadCenario(faixa) {
        const id = `${this.idPredicao}-${this.idBaixaTucagem}-${faixa}-${this.variavelValor}`;
        const cenarioEscolhido = this.cenario.dados.cenarioEscolhido;
        const dadosCenario = { dados: this.cenario.dados.grafico };

        if (this._downloadProgressData[id] != undefined) return;

        this.$set(this._downloadProgressData, id, { id });
        this.$toast.info('Preparando seu arquivo para download.', '', { position: 'topRight', timeout: 1200 });

        PredicoesBaixasService.downloadCenario(this.idPredicao, this.idBaixaTucagem, cenarioEscolhido, dadosCenario, {
          timeout: 60 * 60 * 1000,
          onDownloadProgress: (progressEvent) => {
            let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            let isComputable = progressEvent.lengthComputable;
            this.$set(this._downloadProgressData, id, { progress, isComputable, id });
          }
        })
          .then(async (response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Predicoes_baixas_${this.idPredicao}_analise_cenarios_${id}.xlsx`);
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error('Erro no download do arquivo.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.$delete(this._downloadProgressData, id);
          });
      },
      setarCenario(cenario) {
        const cenarioEscolhido = this.cenario.dados.cenarioEscolhido;

        cenario.id_baixa_tucagem = this.idBaixaTucagem;
        cenario.id_cenario_escolhido = cenarioEscolhido;

        this.loadingSetarCenario = true;

        PredicoesBaixasService.setarCenarioVinculado(this.idPredicao, cenario)
          .then(() => this.$toast.success(`Cenário [${cenario.titulo}] setado com sucesso.`, '', { position: 'topRight' }))
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao setar cenário.', '', { position: 'topRight' });
          })
          .finally(() => (this.loadingSetarCenario = false));
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .predicoes-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .predicoes-table table tr td:nth-child(7),
    .predicoes-table table tr td:nth-child(8) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-predicoes {
      width: 186.95px !important;
    }
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
